import { Phone } from "lucide-react";
import { Reveal } from "./Reveal";
import { WaButton } from "./WaButton";
import { PHONE_DISPLAY, PHONE_TEL } from "@/lib/constants";

export default function CtaFinal() {
  return (
    <section data-testid="hidropro-cta-final-section" className="relative overflow-hidden bg-gradient-to-br from-[#0A5C8C] to-brand-ink py-16 md:py-24 lg:py-28">
      <div className="absolute inset-0 bg-blueprint-dark" />
      <div
        className="pointer-events-none absolute left-1/2 top-0 h-[420px] w-[720px] -translate-x-1/2 -translate-y-1/2 rounded-full"
        style={{ background: "radial-gradient(circle, rgba(0,163,224,0.3) 0%, transparent 70%)" }}
      />
      <div className="relative mx-auto flex max-w-4xl flex-col items-center px-4 text-center sm:px-6">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-water">Solicite um orçamento pelo WhatsApp</p>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-5 font-display text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl lg:text-5xl">
            Precisa de um serviço hidráulico ou elétrico?
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="mt-5 text-base leading-relaxed text-white/75 sm:text-lg">
            Entre em contato com a HidroPro Serviços Técnicos, explique sua necessidade e consulte as possibilidades de
            atendimento para sua região.
          </p>
        </Reveal>
        <Reveal delay={0.24}>
          <div className="mt-9 flex flex-col items-center gap-5 sm:flex-row">
            <WaButton big testId="hidropro-final-whatsapp-button" className="w-full sm:w-auto" />
            <a
              href={PHONE_TEL}
              data-testid="hidropro-final-phone-link"
              className="inline-flex h-14 items-center gap-2.5 rounded-full border border-white/30 px-7 font-display text-base font-bold text-white transition-colors duration-300 hover:bg-white/10 sm:text-lg"
            >
              <Phone className="h-5 w-5" />
              {PHONE_DISPLAY}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
